var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTypeon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.875 6.588c-.937 1.177-1.452 2.847-1.452 4.759v4.361h11.154v-4.361c0-1.912-.515-3.582-1.452-4.76C15.204 5.43 13.838 4.7 12 4.7s-3.204.729-4.125 1.888Zm11.102 9.12v-4.361c0-2.146-.577-4.149-1.756-5.63C16.027 4.215 14.255 3.3 12 3.3s-4.027.916-5.221 2.416C5.6 7.198 5.023 9.201 5.023 11.347v4.361H3.5v1.4h4.836C8.362 19.102 9.998 20.7 12 20.7c2.002 0 3.639-1.598 3.664-3.592H20.5v-1.4h-1.523Zm-4.713 1.4H9.736A2.252 2.252 0 0 0 12 19.3c1.24 0 2.238-.982 2.264-2.192Z",
  fill: "currentColor"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 7,
  r: 4,
  fill: "#FF2525"
})));
export { SvgTypeon as ReactComponent };
export default __webpack_public_path__ + "723434aec9fc8bb6f34ed116fb367cfc.svg";